const state = {
  loading: true,
  loginInfo: null,
  domainLoginUrl: null,
  layoutWidth: 1100,
  pageHeight: true,
}

export default state
